export const contentTableConfig = {
  title: '直播成交指标',
  propList: [
    { prop: 'drawName', label: '活动名称', minWidth: '80'},
    { prop: 'startTime', label: '开始时间', minWidth: '100' },
    { prop: 'endTime', label: '结束时间', minWidth: '80' },
    { prop: 'keywords', label: '关键词', minWidth: '60' },
    {
      label: '操作',
      minWidth: '120',
      slotName: 'handler'
    }
  ],
  showSelectColumn: false,
}